export const getSOCartPagingSelector = (state) => state.personalizeOfferReducer.getSOCartPagingReducer;
